import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from '../../../utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class DetailedSettlementReportService {

  constructor(
    private http: HttpService,
  ) { }

  getChainFilter(data?: any) {
    return this.http.post(Path.DETAILED_SETTLEMENT_REPORT.CHAIN_FILTER, data);
  }

  getIslandGroupFilter(data?: any) {
    return this.http.post(Path.DETAILED_SETTLEMENT_REPORT.ISLAND_GROUP_FILTER, data);
  }

  getRegionFilter(data?: any) {
    return this.http.post(Path.DETAILED_SETTLEMENT_REPORT.REGION_FILTER, data);
  }

  getProvinceFilter(data?: any) {
    return this.http.post(Path.DETAILED_SETTLEMENT_REPORT.PROVINCE_FILTER, data);
  }

  getCityFilter(data?: any) {
    return this.http.post(Path.DETAILED_SETTLEMENT_REPORT.CITY_FILTER, data);
  }

  getCampaignFilter(data?: any) {
    return this.http.post(Path.DETAILED_SETTLEMENT_REPORT.CAMPAIGN_FILTER, data);
  }

  getCategoryFilter(data?: any) {
    return this.http.post(Path.DETAILED_SETTLEMENT_REPORT.CATEGORY_FILTER, data);
  }

  getBrandFilter(data?: any) {
    return this.http.post(Path.DETAILED_SETTLEMENT_REPORT.BRAND_FILTER, data);
  }

  getSkuFilter(data?: any) {
    return this.http.post(Path.DETAILED_SETTLEMENT_REPORT.SKU_FILTER, data);
  }

  generate(data?: any) {
    return this.http.post(Path.DETAILED_SETTLEMENT_REPORT.GENERATE, data);
  }

}